import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Zap } from "lucide-react";

const HIDDEN = ["/apply", "/thank-you", "/state", "/contact", "/for-employers"];

export default function StickyApplyBar() {
  const { pathname } = useLocation();
  const nav = useNavigate();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 520);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [pathname]);

  if (HIDDEN.some((p) => pathname.startsWith(p))) return null;

  const go = () => {
    if (pathname === "/") document.getElementById("quick-match")?.scrollIntoView({ behavior: "smooth", block: "start" });
    else nav("/", { state: { focusMatch: true } });
  };

  return (
    <div className={`md:hidden fixed bottom-0 inset-x-0 z-40 p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] bg-[#0F2A1F]/95 backdrop-blur-lg border-t border-white/10 transition-transform duration-300 ${show ? "translate-y-0" : "translate-y-full"}`} data-testid="sticky-apply-bar">
      <div className="flex items-center gap-3">
        <div className="flex-1 min-w-0 text-white">
          <div className="text-sm font-bold leading-tight">Remote jobs in all 50 states</div>
          <div className="text-[11px] text-white/60">Free · 30-second form</div>
        </div>
        <button onClick={go} className="h-12 px-5 rounded-xl bg-[#D4AF37] text-[#0F2A1F] text-sm font-bold inline-flex items-center gap-1.5 active:scale-95 transition-transform" data-testid="sticky-apply-btn">
          <Zap className="h-4 w-4" /> Get matched
        </button>
      </div>
    </div>
  );
}
